import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { api, errMsg } from "../lib/api";

export const ForgotPasswordForm = ({ onBack }) => {
  const [identifier, setIdentifier] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/forgot-password", { identifier });
      setMsg(r.data.message);
    } catch (err) {
      setError(errMsg(err, "Permintaan gagal, coba lagi."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="auth-form">
      <p className="eyebrow">LUPA PASSWORD</p>
      <h2>Reset password</h2>
      <p className="muted">Masukkan email atau nomor telepon akun Anda. Link reset akan dikirim ke email terdaftar.</p>
      <form onSubmit={submit} data-testid="forgot-form">
        <label>Email atau nomor telepon<input required value={identifier} onChange={(e) => setIdentifier(e.target.value)} data-testid="forgot-identifier-input" /></label>
        {msg && <div className="notice" data-testid="forgot-success-message">{msg}</div>}
        {error && <div className="error" data-testid="forgot-error">{error}</div>}
        <button className="primary full" disabled={busy || !!msg} data-testid="forgot-submit-button">{busy ? "Mengirim…" : "Kirim link reset"} <ChevronRight size={17} /></button>
      </form>
      <button className="text-button" onClick={onBack} data-testid="forgot-back-button">Kembali ke halaman masuk</button>
    </div>
  );
};

export const ResetPasswordForm = ({ token, onDone }) => {
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Konfirmasi password tidak sama.");
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/reset-password", { token, password: form.password });
      setMsg(r.data.message);
    } catch (err) {
      setError(errMsg(err, "Reset gagal, minta link baru."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="auth-form">
      <p className="eyebrow">PASSWORD BARU</p>
      <h2>Buat password baru</h2>
      <p className="muted">Minimal 6 karakter. Setelah berhasil, semua sesi lama otomatis keluar.</p>
      {msg ? (
        <>
          <div className="notice" data-testid="reset-success-message">{msg}</div>
          <button className="primary full" onClick={onDone} data-testid="reset-go-login-button">Masuk sekarang <ChevronRight size={17} /></button>
        </>
      ) : (
        <form onSubmit={submit} data-testid="reset-form">
          <label>Password baru<input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password-input" /></label>
          <label>Ulangi password<input type="password" required minLength={6} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm-input" /></label>
          {error && <div className="error" data-testid="reset-error">{error}</div>}
          <button className="primary full" disabled={busy || !token} data-testid="reset-submit-button">{busy ? "Menyimpan…" : "Simpan password"} <ChevronRight size={17} /></button>
          {!token && <div className="error" data-testid="reset-missing-token">Link tidak lengkap. Minta link reset baru.</div>}
        </form>
      )}
      <button className="text-button" onClick={onDone} data-testid="reset-back-button">Kembali ke halaman masuk</button>
    </div>
  );
};
